import styled, { css } from 'styled-components'
import { CellProps } from './types'

const background = {
  default: css`
    ${({ theme }) => theme.color.background.neutral.default}
  `,
  neutral: css`
    ${({ theme }) => theme.color.background.neutral.weak}
  `,

  hightlighted: '#ffd6d640',
}

export const Content = styled.td<CellProps>`
  background: ${({ variant }) => background[variant]};
  height: 96px;
  display: flex;
  align-items: center;

  border-bottom: 1px solid;

  border-color: ${({ theme, variant }) => (variant === 'hightlighted' ? theme.color.background.brand.weak : '#dddfe4')};

  ${({ variant }) =>
    variant !== 'default' &&
    css`
      align-items: center;
      justify-content: center;
    `}
`
